import {Component, Input, Optional} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-button-cancel',
    template: `

    <button *ngIf="isModal" type="button" class="btn btn-secondary mr-1" (click)="modalRef.hide()"><i class="fa fa-undo"></i>  {{ "cancel" | translate}} </button>

    <button *ngIf="!isModal" type="button" class="btn btn-secondary mr-1" [queryParams]="queryParams"
              [routerLink]="route" fragment="{{ fragment }}"><i class="fa fa-undo"></i> {{ "cancel" | translate}} </button>
  `,
    standalone: false
})
export class ButtonCancelComponent {

  constructor(@Optional() public modalRef: BsModalRef){};

  @Input() route: string;

  @Input() fragment: null;

  @Input() queryParams = {};

  @Input() isModal = false;
}

